import React, { useState } from "react";
import {
  Table,
  Modal,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Radio,
} from "antd";
import moment from "moment";
import { Menu, Icon, Dropdown as DropDown1 } from "antd";
import swal from "sweetalert";
import axios from "axios";
import menuIcon from "../../../../assets/images/DeathModuleNew/Menu.png";
const { Option } = Select;

const ExpandedRowRender = ({
  record,
  addRow,
  setAddRow,
  setLoading,
  setExpandedRow,
  expandedData,
  deleteStockItem,
  getStocksDetails,
  calculateRealizedGain,
  handleExpandRowSave, // for json creation not one by one api call
  handleExpandRowUpdate, // for json creation not one by one api call
}) => {
  const nestedData =
    expandedData &&
    expandedData.filter((item) => item.tickerSymbol === record.tickerSymbol);
  const [editingKey, setEditingKey] = useState("");
  const [editingRow, setEditingRow] = useState({});
  const [AddRowData, setAddRowData] = useState({});

  const handleCancelAddRow = () => {
    setAddRow(false);
    setAddRowData({});
  };
  const handleSaveAddRow = async () => {
    setAddRow(false);
    console.log("data clieck", record);
    if (record && record.name) {
      const newStockData = {
        ...AddRowData,
        clientStockId: record.id,
        tickerSymbol: record.tickerSymbol,
        parentShares: AddRowData.shares && +AddRowData.shares,
        approximateMarketValue: calculateMarketValue(
          AddRowData.shares,
          AddRowData.pricePerShare,
          AddRowData.commission,
          AddRowData.commissionType
        ),
        shares: AddRowData.shares && +AddRowData.shares,
        commission: AddRowData.commission && +AddRowData.commission,
        created: "newly",
      };
      handleExpandRowSave(newStockData);
      // try {
      //   setLoading(true);
      //   const userToken = localStorage.getItem("userLoginToken");
      //   const baseUrl = "https://sam.assetplanet.com/plaid-service";
      //   const response = await axios.post(`${baseUrl}/stocks`, newStockData, {
      //     headers: {
      //       Authorization: `Bearer ${userToken}`,
      //     },
      //   });
      //   console.log("response", response);
      //   if (response && response.data && response.data.status === 200) {
      //     await getStocksDetails();
      //     swal("Success", response.data.message, "success");
      //   }
      //   if (response && response.data && response.data.status === 400) {
      //     swal("Error", response.data.message, "error");
      //   }
      //   setLoading(false);
      // } catch (error) {
      //   setLoading(false);
      //   if (error && error.response && error.response.data) {
      //     swal("Error", error.response.data.message, "error");
      //   }
      //   console.error("Error fetching user data:", error);
      // }
      // setStockBuyData({});
    } else {
      console.error("expandedRow or expandedRow.name is not defined");
    }
    setExpandedRow(null);
    setAddRowData({});
  };

  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    setEditingKey(record.id);
    setEditingRow({ ...record });
    // setExpandedRow(dataOpen);
    // setStockBuyData(record)
  };
  const handleSaveDetails = async (e) => {
    e.preventDefault();
    if (editingRow) {
      handleExpandRowUpdate(editingRow);
      // try {
      //   setLoading(true);
      //   const userToken = localStorage.getItem("userLoginToken");
      //   const baseUrl = "https://sam.assetplanet.com/plaid-service";
      //   const response = await axios.put(
      //     `${baseUrl}/stocks?stockId=${editingRow.id}`,
      //     editingRow,
      //     {
      //       headers: {
      //         Authorization: `Bearer ${userToken}`,
      //       },
      //     }
      //   );
      //   console.log("response", response);
      //   if (response && response.data && response.data.status === 200) {
      //     swal("Success", response.data.message, "success");
      //   }
      //   await getStocksDetails();
      //   setLoading(false);
      // } catch (error) {
      //   setLoading(false);
      //   if (error && error.data && error.data.message) {
      //     swal("Success", error.data.message, "success");
      //   }
      //   console.error("Error fetching user data:", error);
      // }
    }
    setEditingKey("");
    // setStockUpdate(false);
    setExpandedRow(null);
    // setStockBuyData({});
  };
  const cancel = () => {
    setEditingKey("");
  };

  const handleInputChange = (value, fieldName) => {
    setEditingRow((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };
  const handleAddInputChange = (value, fieldName) => {
    setAddRowData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };
  const calculateMarketValue = (
    noOfShares,
    pricePerShare,
    commission,
    commissionType
  ) => {
    const shares = noOfShares ? +noOfShares : 0;
    const price = pricePerShare ? +pricePerShare : 0;
    let commissions = 0;
    if (commissionType && commissionType === "Flat Fee") {
      commissions = commission ? +commission : 0;
    } else {
      const priceTotal = shares * price;
      commissions = commission ? (+commission / 100) * priceTotal : 0;
    }
    return shares * price - commissions;
  };
  const columns = [
    {
      title: "Buy/Sell",
      dataIndex: "buySell",
      sorter: (a, b) => (a.buySell || "").localeCompare(b.buySell || ""),
      render: (text, record) =>
        isEditing(record) ? (
          <Select
            showSearch
            placeholder="-Select-"
            value={editingRow && editingRow.buySell}
            onChange={(value, id) => {
              handleInputChange(value, "buySell");
            }}>
            {[{ name: "Buy" }, { name: "Sell" }].map((item, index) => (
              <Option key={index} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        ) : (
          text || "N/A"
        ),
    },
    {
      title: "Trade Date",
      dataIndex: "tradeDate",
      defaultSortOrder: "descend",
      sorter: (a, b) => (a.tradeDate || "").localeCompare(b.tradeDate || ""),
      render: (text, record) =>
        isEditing(record) ? (
          <DatePicker
            style={{
              width: "100%",
              border: "1px solid #d1d5db",
              borderRadius: "5px",
            }}
            size="large"
            format={"MM/DD/YYYY"}
            placeholder="Trade Date"
            name="tradeDate"
            value={
              editingRow &&
              editingRow.tradeDate &&
              moment.utc(editingRow.tradeDate)
            }
            id="newDate"
            onChange={(date, dateString) => {
              handleInputChange(dateString, "tradeDate");
            }}
          />
        ) : text ? (
          moment(text).format("MM-DD-YYYY")
        ) : (
          "N/A"
        ),
    },
    {
      title: "Shares",
      dataIndex: "shares",
      sorter: (a, b) => {
        const amountA = parseFloat(a.shares);
        const amountB = parseFloat(b.shares);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (text, record) =>
        isEditing(record) ? (
          <input
            className="roleInput"
            placeholder="Shares"
            name="shares"
            value={editingRow && editingRow.shares}
            id="shares"
            onChange={(e) => {
              e.preventDefault();
              handleInputChange(e.target.value, "shares");
            }}
          />
        ) : text ? (
          text
        ) : (
          "N/A"
        ),
    },
    {
      title: "Price/Share",
      dataIndex: "pricePerShare",
      sorter: (a, b) => {
        const amountA = parseFloat(a.pricePerShare);
        const amountB = parseFloat(b.pricePerShare);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (text, record) =>
        isEditing(record) ? (
          <div className="inputWrapper" style={{ display: "flex" }}>
            <span
              style={{
                fontSize: "15px",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                color: "rgba(0, 0, 0, 0.65)",
                background: "#fafafa",
                borderRadius: "4px",
                border: "1px solid #d1d5db",
              }}>
              $
            </span>
            <InputNumber
              step={1}
              formatter={(value) =>
                ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Price Per Share"
              name="pricePerShare"
              value={editingRow && editingRow.pricePerShare}
              onChange={(value) => {
                handleInputChange(value, "pricePerShare");
              }}
            />
          </div>
        ) : text ? (
          `$${parseFloat(text)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        ) : (
          "N/A"
        ),
    },
    {
      title: "Commission Type",
      dataIndex: "commissionType",
      sorter: (a, b) =>
        (a.commissionType || "").localeCompare(b.commissionType || ""),
      render: (text, record) =>
        isEditing(record) ? (
          <Select
            showSearch
            placeholder="-Select-"
            value={editingRow && editingRow.commissionType}
            onChange={(value, id) => {
              handleInputChange(value, "commissionType");
            }}>
            {[{ name: "Percent" }, { name: "Flat Fee" }].map((item, index) => (
              <Option key={index} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        ) : (
          text || "N/A"
        ),
    },
    {
      title: "Commission",
      dataIndex: "commission",
      sorter: (a, b) => {
        const amountA = parseFloat(a.commission);
        const amountB = parseFloat(b.commission);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (text, record) =>
        isEditing(record) ? (
          <div className="inputWrapper" style={{ display: "flex" }}>
            {editingRow.commissionType &&
              editingRow.commissionType === "Flat Fee" && (
                <span className="dollarSymbol">$</span>
              )}
            <InputNumber
              step={1}
              formatter={(value) =>
                ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Commission"
              name="commission"
              value={editingRow && editingRow.commission}
              id="commission"
              onChange={(value) => {
                handleInputChange(value, "commission");
              }}
            />
            {editingRow.commissionType &&
              editingRow.commissionType !== "Flat Fee" && (
                <span className="dollarSymbol">%</span>
              )}
          </div>
        ) : record.commissionType && record.commissionType === "Flat Fee" ? (
          text ? (
            `$${text
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : (
            "N/A"
          )
        ) : text ? (
          `${text.toFixed(2)}%`
        ) : (
          "N/A"
        ),
    },
    {
      title: "Market Value",
      dataIndex: "approximateMarketValue",
      sorter: (a, b) => {
        const amountA = parseFloat(a.approximateMarketValue);
        const amountB = parseFloat(b.approximateMarketValue);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (text, record) =>
        isEditing(record) ? (
          <div className="inputWrapper" style={{ display: "flex" }}>
            <span className="dollarSymbol">$</span>
            <InputNumber
              step={1}
              formatter={(value) =>
                ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Market Value"
              name="approximateMarketValue"
              value={editingRow && editingRow.approximateMarketValue}
              id="commission"
              onChange={(value) => {
                handleInputChange(value, "approximateMarketValue");
              }}
            />
          </div>
        ) : text ? (
          `$${text
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        ) : (
          "N/A"
        ),
    },
    {
      title: "Realized Gain",
      dataIndex: "realizedGain",
      sorter: (a, b) => {
        const amountA = parseFloat(a.realizedGain);
        const amountB = parseFloat(b.realizedGain);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (text, record) =>
        record ? calculateRealizedGain(record) : "N/A",
    },
    // {
    //   title: "Name",
    //   dataIndex: "name",
    //   key: "name",
    //   sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    //   render: (text, record) =>
    //     isEditing(record) ? (
    //       <Input
    //         value={editingRow && editingRow.name}
    //         onChange={(e) => handleInputChange(e.target.value, "name")}
    //       />
    //     ) : (
    //       text || "N/A"
    //     ),
    // },
    {
      title: "Action",
      render: (_, record) => {
        const editable = isEditing(record);
        // console.log("editable",editable)
        return editable ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "1rem",
              flexWrap: "wrap",
              alignItems: "center",
            }}>
            <button
              style={{ width: "fit-content" }}
              className="savebutton"
              onClick={(e) => handleSaveDetails(e)}>
              Save
            </button>
            <button
              style={{ width: "fit-content" }}
              className="cancelbutton"
              onClick={cancel}>
              Cancel
            </button>
          </div>
        ) : (
          <DropDown1
            trigger={["click"]}
            overlay={
              <Menu>
                <Menu.Item
                  onClick={() => {
                    edit(record);
                    // setStockUpdate(true);
                    // setExpandedRow(dataClicked);
                    // setStockBuyData(record)
                  }}>
                  Update
                </Menu.Item>
                <Menu.Item onClick={() => deleteStockItem(record.id, record)}>
                  Delete
                </Menu.Item>
              </Menu>
            }>
            <div
              onClick={(e) => e.preventDefault()}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <a className="ant-dropdown-link">
                <img src={menuIcon} alt="menuIcon" />
              </a>
            </div>
          </DropDown1>
        );
      },
    },
  ];

  return (
    <div>
      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "end",
        }}>
        <button
          className="addbuttonassets"
          onClick={(e) => {
            e.preventDefault();
            setAddRow(true);
          }}>
          + Add Row
        </button>
      </div>
      {addRow && (
        <Modal
          visible={addRow}
          footer={null}
          onOk={handleCancelAddRow}
          onCancel={handleCancelAddRow}
          closable={false}
          centered>
          <h3 className="modaltitle">Add Stock Details</h3>

          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Buy/Sell</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={AddRowData && AddRowData.buySell}
              onChange={(value, id) => {
                handleAddInputChange(value, "buySell");
              }}>
              {[{ name: "Buy" }, { name: "Sell" }].map((item, index) => (
                <Option key={index} value={item.name}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Trade Date</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Trade Date"
              name="tradeDate"
              value={
                AddRowData &&
                AddRowData.tradeDate &&
                moment.utc(AddRowData.tradeDate)
              }
              id="newDate"
              onChange={(date, dateString) => {
                handleAddInputChange(dateString, "tradeDate");
              }}
            />
          </div>

          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Shares</h3>
            <input
              className="roleInput"
              placeholder="Shares"
              name="shares"
              value={AddRowData && AddRowData.shares}
              id="shares"
              onChange={(e) => {
                e.preventDefault();
                handleAddInputChange(e.target.value, "shares");
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Price Per Share</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}>
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Price Per Share"
                name="pricePerShare"
                value={AddRowData && AddRowData.pricePerShare}
                // id="amount"
                onChange={(value) => {
                  handleAddInputChange(value, "pricePerShare");
                }}
              />
            </div>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Commission</h3>
            <Radio.Group
              buttonStyle="solid"
              name="commissionType"
              value={AddRowData && AddRowData.commissionType}
              defaultValue={"Percent"}
              onChange={(e) => {
                handleAddInputChange(e.target.value, "commissionType");
              }}>
              {["Percent", "Flat Fee"].map((value, vindex) => (
                <Radio.Button key={vindex} value={value}>
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
          <div style={{ marginBottom: "8px" }}>
            {AddRowData && AddRowData.commissionType === "Flat Fee" ? (
              <div className="inputWrapper" style={{ display: "flex" }}>
                <span className="dollarSymbol">$</span>
                <InputNumber
                  step={1}
                  formatter={(value) =>
                    ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  className="Input"
                  placeholder="Commission"
                  name="commission"
                  value={AddRowData && AddRowData.commission}
                  id="commission"
                  onChange={(value) => {
                    handleAddInputChange(value, "commission");
                  }}
                />
              </div>
            ) : (
              <input
                className="roleInput"
                placeholder="Percentage"
                name="commission"
                value={AddRowData && AddRowData.commission}
                id="commission"
                onChange={(e) => {
                  e.preventDefault();
                  handleAddInputChange(e.target.value, "commission");
                }}
              />
            )}
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancelAddRow();
              }}>
              Cancel
            </button>
            <button
              className="savebutton"
              // disabled={!formData || !formData.subCategoryName}
              onClick={() => {
                handleSaveAddRow();
              }}>
              Save
            </button>
          </div>
        </Modal>
      )}
      <Table
        className="nestedDataTable"
        columns={columns}
        dataSource={nestedData}
        pagination={true}
        rowKey="id"
      />
    </div>
  );
};

export default ExpandedRowRender;
